import { render, staticRenderFns } from "./InputWithSuggestions.vue?vue&type=template&id=2dcb6c20"
import script from "./InputWithSuggestions.vue?vue&type=script&lang=js"
export * from "./InputWithSuggestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports